import { Container } from "@pixi/display";
import { IDestroyOptions, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../../common/GameFont";
import { ButtonWithScaleAnimation } from "../../../../common/components/ButtonWithScaleAnimation";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { IBenefitsModel } from "../../../../common/models/benefits/IBenefitsModel";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";

export class DiscountContainer extends Container {
    private readonly commonResources: CommonResourcesPackage;
    private readonly benefitsModel: IBenefitsModel;
    private discountButton: ButtonWithScaleAnimation;
    private daysCountText: Text;

    public get button(): ButtonWithScaleAnimation {
        return this.discountButton;
    }

    public constructor(
        commonResources: CommonResourcesPackage,
        benefitsModel: IBenefitsModel
    ) {
        super();
        this.commonResources = commonResources;
        this.benefitsModel = benefitsModel;
        this.build();
    }

    private build(): void {
        this.discountButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_ui_discount_coupon_png);
        this.discountButton.width = this.discountButton.height = 120;
        this.addChild(this.discountButton);
        const benefitWithMinTime = this.benefitsModel.benefits.value?.length > 0 ? this.benefitsModel.benefits.value.reduce((previous, current) => {
            return previous.endsIn < current.endsIn ? previous : current;
        }) : null;
        this.daysCountText = new Text(`EXPIRE IN\n${StringFormatExtention.expiresFromMsFormat(benefitWithMinTime?.endsIn ?? 0)}`, new DaysCountTextStyle());
        this.daysCountText.position.y = this.discountButton.y + this.discountButton.height + 10;
        this.addChild(this.daysCountText);
        this.daysCountText.visible = benefitWithMinTime != null && benefitWithMinTime?.endsIn > 0;
        if (benefitWithMinTime?.endsIn && (benefitWithMinTime.endsIn / 60000) < 60) {
            this.daysCountText.style = new DaysCountRedTextStyle();
        }
    }
}

class DaysCountTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36
        }));
    }
}

class DaysCountRedTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: [
                "#ff4d4d",
                "#ff03ba"
            ],
            fillGradientType: 0,
            fillGradientStops: [
                0.3
            ],
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36
        }));
    }
}
